<!-- <ion-badge color="dark" class="text-left leading-tight" [innerHTML]="showStar(item.WL008)"
(click)="qryMaster.toggleStar(item,false)">
</ion-badge> -->
<!-- <mat-chip color="dark" (click)="doClick($event)">
  <mat-icon  name="person-circle"></mat-icon>
  <div class="text-2xl">
    <mat-label>{{showStar(value)}}</mat-label>
  </div>
</mat-chip> -->
<div class="w-1 text-2xl"> <!-- class="text-2xl text-left leading-tight" -->
  <button class="w-10 h-10 mr-2 shrink-0" (click)="doClick($event)">  <!-- class="btn jk-button-small" [class.btn-second]="true" -->
    {{showStar(value)}}
  </button>
</div>
